import request from '@/utils/request'

// 获取加密公钥
export function getPublicKey() {
    return request({
        url: '/upms/system/rsa/public-key',
        method: 'get',
        params: {
            APPID: import.meta.env.VITE_APP_APPID
        }
    })
}

// 登录
export function login(data) {
    return request({
        url: '/upms/login/login',
        method: 'post',
        data
    })
}

//登出
export function logout() {
    return request({
        url: '/upms/login/logout',
        method: 'post'
    })
}

// 获取用户信息
export function getInfo() {
    return request({
        url: '/upms/login/info',
        method: 'get',
    })
}

//获取用户菜单
export function getRouters() {
    return request({
        url: '/upms/menu/getRouters',
        method: 'get',
    })
}

//获取项目字典
export function getDict() {
    return request({
        url: '/upms/dict/cache-value',
        method: 'get',
    })
}

//获取项目日志
export function getLogList(data) {
    return request({
        url: '/upms/log',
        method: 'postJson',
        data
    })
}